import { Injectable } from '@angular/core';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { ListServerPaginationStateModel, LIST_SERVER_PAGINATION_INITIAL_STATE } from '../../../../../common/models';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { AllocationViewProfileListService } from './allocation-view-profile-list.service';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { AllocationViewProfile } from '../models';
import {
  AllocationViewProfileListInitialState,
  AllocationViewProfileListLoad,
} from './allocation-view-profile-list.actions';
import { CustomHttpErrorResponse, Error } from '../../../../../common/constants/error';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export type AllocationViewProfileListStateModel = ListServerPaginationStateModel<AllocationViewProfile>;

const initialState: AllocationViewProfileListStateModel = LIST_SERVER_PAGINATION_INITIAL_STATE;

@State<AllocationViewProfileListStateModel>({
  name: 'allocationViewProfileList',
  defaults: initialState,
})
@Injectable()
export class AllocationViewProfileListState {
  @Selector()
  static getState(state: AllocationViewProfileListStateModel): AllocationViewProfileListStateModel {
    return state;
  }

  @Selector()
  static getItems(state: AllocationViewProfileListStateModel): AllocationViewProfile[] {
    return state.items;
  }

  @Selector()
  static getLoaded(state: AllocationViewProfileListStateModel): boolean {
    return state.loaded;
  }

  constructor(
    private notificationService: NotificationService,
    private allocationViewProfilesService: AllocationViewProfileListService,
  ) {}

  @Action(AllocationViewProfileListLoad)
  loadProfiles(
    ctx: StateContext<AllocationViewProfileListStateModel>,
    { payload }: AllocationViewProfileListLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.allocationViewProfilesService.getProfiles(payload).pipe(
      map((profilesDto: AllocationViewProfileListStateModel) => {
        ctx.patchState({
          ...profilesDto,
          loaded: true,
        });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(AllocationViewProfileListInitialState)
  setInitialState(ctx: StateContext<AllocationViewProfileListStateModel>): void {
    ctx.setState(initialState);
  }
}
